/**
 * A/B Test V4: Curated Quick-Start Bundles (no discount)
 *
 * 50/50 cookie-based split.
 * Variant A = unchanged page (control).
 * Variant B = Pre-curated 4-charm bundle cards above the existing builder.
 *
 * Loaded only on /products/build-your-charm-set via product-template.liquid.
 * CSS URL passed via data-css-url attribute on this script tag.
 */

(function () {
  'use strict';

  /* ========================================================================
     Constants
     ======================================================================== */
  var CLOUDINARY_URL    = 'https://api.cloudinary.com/v1_1/dgwldii6i/image/upload';
  var CLOUDINARY_PRESET = 'ml_unsigned';
  var MAX_IMAGE_SIZE    = 1000;

  /* ========================================================================
     Bundle config
     ======================================================================== */
  var BUNDLES = [
    {
      id: 'faith-memorial',
      name: 'Faith & Memorial',
      heroImg: 'https://cdn.shopify.com/s/files/1/0928/6408/files/memorial_2_1.jpg?v=1777255279',
      charms: [
        'personalized-photo-portrait-charm',
        'cross-charm',
        'wing-charm',
        'birthstone-charm'
      ],
      customCharm: 'personalized-photo-portrait-charm',
      circleRender: 'CIRCLE',
      hasPetFields: false
    },
    {
      id: 'pet-lover',
      name: 'Pet Lover',
      heroImg: 'https://cdn.shopify.com/s/files/1/0928/6408/files/pet_lover_2_1_ea4c2c5e-930c-4166-901d-193426edbfc9.jpg?v=1777255279',
      charms: [
        'personalized-pet-portrait-charm',
        'letter-charm',
        'birthstone-charm',
        'paw-charm'
      ],
      customCharm: 'personalized-pet-portrait-charm',
      circleRender: 'IGNORE',
      hasPetFields: true
    },
    {
      id: 'mothers-day',
      name: 'For Mom',
      heroImg: 'https://cdn.shopify.com/s/files/1/0928/6408/files/mothers_day_2_1.jpg?v=1777255279',
      charms: [
        'personalized-photo-portrait-charm',
        'mama-charm',
        'birthstone-charm',
        'letter-charm'
      ],
      customCharm: 'personalized-photo-portrait-charm',
      circleRender: 'CIRCLE',
      hasPetFields: false
    }
  ];

  var BASES = [
    { handle: 'charm-keeper-beaded-stretch-bracelet', label: 'Keeper Bracelet', colorMap: { gold: 'Multi', silver: 'Turquoise' } },
    { handle: 'paper-clip-chain-bracelet', label: 'Paperclip Bracelet' },
    { handle: 'delicate-charm-keeper-necklace', label: 'Keeper Necklace' }
  ];

  /* ========================================================================
     CSS loader + asset URL helper
     ======================================================================== */
  function getAssetBaseUrl() {
    var scriptTag = document.querySelector('script[data-css-url]');
    if (!scriptTag) return '';
    var cssUrl = scriptTag.getAttribute('data-css-url') || '';
    return cssUrl.substring(0, cssUrl.lastIndexOf('/') + 1);
  }

  function loadCSS() {
    var scriptTag = document.querySelector('script[data-css-url]');
    if (!scriptTag) return;
    var href = scriptTag.getAttribute('data-css-url');
    if (!href) return;
    var link = document.createElement('link');
    link.rel = 'stylesheet';
    link.href = href;
    document.head.appendChild(link);
  }

  /* ========================================================================
     DOM helpers
     ======================================================================== */
  function createEl(tag, attrs, html) {
    var el = document.createElement(tag);
    if (attrs) {
      var keys = Object.keys(attrs);
      for (var i = 0; i < keys.length; i++) {
        el.setAttribute(keys[i], attrs[keys[i]]);
      }
    }
    if (html) el.innerHTML = html;
    return el;
  }

  function insertAfter(newNode, refNode) {
    if (refNode && refNode.parentNode) {
      refNode.parentNode.insertBefore(newNode, refNode.nextSibling);
    }
  }

  function insertBefore(newNode, refNode) {
    if (refNode && refNode.parentNode) {
      refNode.parentNode.insertBefore(newNode, refNode);
    }
  }

  /* ========================================================================
     Product data fetcher
     ======================================================================== */
  function collectAllHandles() {
    var handles = {};
    for (var i = 0; i < BUNDLES.length; i++) {
      var charms = BUNDLES[i].charms;
      for (var j = 0; j < charms.length; j++) {
        handles[charms[j]] = true;
      }
    }
    for (var k = 0; k < BASES.length; k++) {
      handles[BASES[k].handle] = true;
    }
    return Object.keys(handles);
  }

  function fetchAllProductData(callback) {
    var handles = collectAllHandles();
    var productMap = {};
    var completed = 0;
    var failed = false;

    for (var i = 0; i < handles.length; i++) {
      (function (handle) {
        fetch('/products/' + handle + '.json')
          .then(function (res) {
            if (!res.ok) throw new Error('HTTP ' + res.status);
            return res.json();
          })
          .then(function (data) {
            productMap[handle] = data.product;
            completed++;
            if (completed === handles.length && !failed) {
              callback(productMap);
            }
          })
          .catch(function (err) {
            console.error('[AB V4] Failed to fetch product: ' + handle, err);
            failed = true;
          });
      })(handles[i]);
    }
  }

  /* ========================================================================
     Variant resolver — match by color (silver/gold)
     ======================================================================== */
  function getVariantByColor(product, color) {
    if (!product || !product.variants) return null;
    var colorLower = (color || 'silver').toLowerCase();
    for (var i = 0; i < product.variants.length; i++) {
      var v = product.variants[i];
      if (v.available === false) continue;
      var opt1 = (v.option1 || '').toLowerCase();
      var opt2 = (v.option2 || '').toLowerCase();
      var opt3 = (v.option3 || '').toLowerCase();
      if (opt1 === colorLower || opt2 === colorLower || opt3 === colorLower) return v;
    }
    // Fallback: first available variant
    for (var j = 0; j < product.variants.length; j++) {
      if (product.variants[j].available !== false) return product.variants[j];
    }
    return product.variants[0];
  }

  /**
   * Resolve variant by color + a second option (letter or birthstone name).
   */
  function getVariantByColorAndOption(product, color, optionValue) {
    if (!product || !product.variants) return null;
    var colorLower = (color || 'silver').toLowerCase();
    var optLower = (optionValue || '').toLowerCase();
    for (var i = 0; i < product.variants.length; i++) {
      var v = product.variants[i];
      if (v.available === false) continue;
      var opts = [
        (v.option1 || '').toLowerCase(),
        (v.option2 || '').toLowerCase(),
        (v.option3 || '').toLowerCase()
      ];
      var hasColor = opts.indexOf(colorLower) > -1;
      var hasOpt = opts.indexOf(optLower) > -1;
      if (hasColor && hasOpt) return v;
    }
    // Fallback to color-only match
    return getVariantByColor(product, color);
  }

  /* ========================================================================
     Thumbnail URL helper
     ======================================================================== */
  function getThumbUrl(product) {
    if (!product || !product.images || !product.images.length) return '';
    var src = product.images[0].src || '';
    // Use Shopify's image resize for consistent thumbnails
    return src.replace(/\.(\w+)(\?|$)/, '_120x120_crop_center.$1$2');
  }

  /* ========================================================================
     Price helper
     ======================================================================== */
  function formatMoney(dollars) {
    var num = parseFloat(dollars);
    if (isNaN(num)) return '$0';
    var formatted = num.toFixed(2).replace(/\.00$/, '');
    return '$' + formatted;
  }

  function getBaseVariant(base, productMap, color) {
    var product = productMap[base.handle];
    var lookup = (base.colorMap && base.colorMap[color]) || color;
    return getVariantByColor(product, lookup);
  }

  function getBundlePrice(bundle, productMap, color, baseIndex) {
    var total = 0;
    var baseVariant = getBaseVariant(BASES[baseIndex || 0], productMap, color);
    if (baseVariant) total += parseFloat(baseVariant.price) || 0;

    // Charm prices
    for (var i = 0; i < bundle.charms.length; i++) {
      var charmProduct = productMap[bundle.charms[i]];
      var charmVariant = getVariantByColor(charmProduct, color);
      if (charmVariant) total += parseFloat(charmVariant.price) || 0;
    }
    return total;
  }

  function getMinBundlePrice(bundle, productMap, color) {
    var min = Infinity;
    for (var i = 0; i < BASES.length; i++) {
      var p = getBundlePrice(bundle, productMap, color, i);
      if (p > 0 && p < min) min = p;
    }
    return min === Infinity ? 0 : min;
  }

  // Returns the price of the cheapest charm in the bundle (the "free" one)
  function getCheapestCharmPrice(bundle, productMap, color) {
    var min = Infinity;
    for (var i = 0; i < bundle.charms.length; i++) {
      var charmProduct = productMap[bundle.charms[i]];
      var charmVariant = getVariantByColor(charmProduct, color);
      if (charmVariant) {
        var p = parseFloat(charmVariant.price) || 0;
        if (p < min) min = p;
      }
    }
    return min === Infinity ? 0 : min;
  }

  /* ========================================================================
     Bundle card renderer
     ======================================================================== */
  var bundlesContainer = null;

  function renderBundleCards(productMap) {
    // Find insertion point — before the first .charm-builder-title ("1. SELECT YOUR BASE")
    var titles = document.querySelectorAll('.charm-builder-title');
    var insertRef = null;
    for (var t = 0; t < titles.length; t++) {
      var titleText = titles[t].textContent.replace(/\s+/g, ' ');
      if (titleText.indexOf('SELECT YOUR BASE') > -1 ||
          titleText.indexOf('SELECT YOUR COLOR') > -1) {
        insertRef = titles[t];
        break;
      }
    }
    if (!insertRef) return;

    // Build wrapper
    bundlesContainer = createEl('div', { 'class': 'ab-v4-bundles' });

    // Heading
    var heading = createEl('div', { 'class': 'ab-v4-bundles__header' },
      '<h2 class="ab-v4-bundles__title">QUICK START \u2014 PICK A SET</h2>' +
      '<p class="ab-v4-bundles__subtitle">Pre-curated 4-charm bundles. Just add your photo!</p>'
    );
    bundlesContainer.appendChild(heading);

    // Cards row
    var cardsRow = createEl('div', { 'class': 'ab-v4-bundles__cards' });

    for (var i = 0; i < BUNDLES.length; i++) {
      var b = BUNDLES[i];
      var fullPrice = getMinBundlePrice(b, productMap, 'gold');
      var priceHtml =
        '<div class="ab-v4-bundle-card__price">From ' + formatMoney(fullPrice) + '</div>';

      var cardHtml;
      if (b.heroImg) {
        // Hero image card — photo fills top, text below
        cardHtml =
          '<img class="ab-v4-bundle-card__hero" src="' + b.heroImg + '" alt="' + b.name + '" loading="lazy">' +
          '<div class="ab-v4-bundle-card__info">' +
            '<h3 class="ab-v4-bundle-card__name">' + b.name + '</h3>' +
            priceHtml +
            '<button type="button" class="ab-v4-bundle-card__select" style="background:#000;color:#fff;border:2px solid #000;border-radius:0;" data-bundle-index="' + i + '">Select</button>' +
          '</div>';
      } else {
        // Icon + thumbnails card
        var thumbsHtml = '';
        for (var c = 0; c < b.charms.length; c++) {
          var charmProduct = productMap[b.charms[c]];
          var thumb = getThumbUrl(charmProduct);
          var charmTitle = charmProduct ? charmProduct.title : '';
          thumbsHtml += '<img class="ab-v4-bundle-card__thumb" src="' + thumb + '" alt="' + charmTitle + '" loading="lazy">';
        }
        cardHtml =
          '<div class="ab-v4-bundle-card__icon-wrap">' + (b.iconImg ? '<img class="ab-v4-bundle-card__icon" src="' + getAssetBaseUrl() + b.iconImg + '" alt="' + b.name + '">' : b.icon) + '</div>' +
          '<h3 class="ab-v4-bundle-card__name">' + b.name + '</h3>' +
          '<div class="ab-v4-bundle-card__thumbs">' + thumbsHtml + '</div>' +
          priceHtml +
          '<button type="button" class="ab-v4-bundle-card__select" style="background:#000;color:#fff;border:2px solid #000;border-radius:0;" data-bundle-index="' + i + '">Select</button>';
      }

      var card = createEl('div', {
        'class': 'ab-v4-bundle-card' + (b.heroImg ? ' ab-v4-bundle-card--hero' : ''),
        'data-bundle-id': b.id
      }, cardHtml);

      cardsRow.appendChild(card);
    }

    // "Build Your Own" card — scrolls to step 1
    var byoCard = createEl('div', {
      'class': 'ab-v4-bundle-card ab-v4-bundle-card--hero',
      'data-bundle-id': 'build-your-own'
    },
      '<img class="ab-v4-bundle-card__hero" src="https://cdn.shopify.com/s/files/1/0928/6408/files/build_your_own_set_1.jpg?v=1777255279" alt="Build Your Own" loading="lazy">' +
      '<div class="ab-v4-bundle-card__info">' +
        '<h3 class="ab-v4-bundle-card__name">Build Your Own</h3>' +
        '<button type="button" class="ab-v4-bundle-card__select ab-v4-byo-btn" style="background:#000;color:#fff;border:2px solid #000;border-radius:0;">Select</button>' +
      '</div>'
    );
    cardsRow.appendChild(byoCard);

    bundlesContainer.appendChild(cardsRow);

    // Divider
    var divider = createEl('div', { 'class': 'ab-v4-divider' },
      '<span class="ab-v4-divider__line"></span>' +
      '<span class="ab-v4-divider__text">or build your own below</span>' +
      '<span class="ab-v4-divider__line"></span>'
    );
    bundlesContainer.appendChild(divider);

    // Insert before the builder title
    insertBefore(bundlesContainer, insertRef);

    // Attach select button listeners (bundle cards)
    var selectBtns = bundlesContainer.querySelectorAll('.ab-v4-bundle-card__select[data-bundle-index]');
    for (var s = 0; s < selectBtns.length; s++) {
      selectBtns[s].addEventListener('click', function (e) {
        var idx = parseInt(e.target.getAttribute('data-bundle-index'), 10);
        renderConfigPanel(BUNDLES[idx], productMap);
      });
    }

    // Build Your Own — scroll to step 1
    var byoBtn = bundlesContainer.querySelector('.ab-v4-byo-btn');
    if (byoBtn) {
      byoBtn.addEventListener('click', function () {
        if (insertRef) {
          var headerOffset = document.querySelector('.site-header') ? document.querySelector('.site-header').offsetHeight : 0;
          var top = insertRef.getBoundingClientRect().top + window.pageYOffset - headerOffset;
          window.scrollTo({ top: top, behavior: 'smooth' });
        }
      });
    }
  }

  /* ========================================================================
     Configuration panel
     ======================================================================== */
  var LETTERS = 'A,B,C,D,E,F,G,H,I,J,K,L,M,N,O,P,Q,R,S,T,U,V,W,X,Y,Z'.split(',');
  var BIRTHSTONES = [
    { month: 'January', stone: 'Garnet', hex: '#9B111E' },
    { month: 'February', stone: 'Amethyst', hex: '#9966CC' },
    { month: 'March', stone: 'Aquamarine', hex: '#7FFFD4' },
    { month: 'April', stone: 'Diamond', hex: '#E8E8E8' },
    { month: 'May', stone: 'Emerald', hex: '#50C878' },
    { month: 'June', stone: 'Alexandrite', hex: '#8B7DAA' },
    { month: 'July', stone: 'Ruby', hex: '#E0115F' },
    { month: 'August', stone: 'Peridot', hex: '#B4C424' },
    { month: 'September', stone: 'Sapphire', hex: '#0F52BA' },
    { month: 'October', stone: 'Opal', hex: '#D4EAEB' },
    { month: 'November', stone: 'Yellow Topaz', hex: '#FFC87C' },
    { month: 'December', stone: 'Blue Zircon', hex: '#57C4E5' }
  ];

  var configState = {
    bundle: null,
    baseIndex: 0,
    color: 'gold',
    photoUrl: null,
    petName: '',
    petBackground: 'Light Gray',
    initial: 'A',
    birthstone: 'Garnet'
  };

  function closeModal() {
    var overlay = document.querySelector('.ab-v4-modal');
    if (!overlay) return;
    var sheet = overlay.querySelector('.ab-v4-modal__sheet');
    if (sheet) sheet.classList.remove('ab-v4-modal__sheet--open');
    overlay.classList.remove('ab-v4-modal--open');
    document.body.classList.remove('ab-v4-modal-open');
    document.body.style.overflow = '';
    setTimeout(function () { overlay.remove(); }, 300);
  }

  function renderConfigPanel(bundle, productMap) {
    configState.bundle = bundle;
    configState.photoUrl = null;
    configState.petName = '';
    configState.petBackground = 'Light Gray';
    configState.baseIndex = 0;
    configState.color = 'gold';
    configState.initial = 'A';
    configState.birthstone = 'Garnet';

    // Remove any existing modal
    var existing = document.querySelector('.ab-v4-modal');
    if (existing) existing.remove();

    // Build charm selector dropdowns
    var hasLetter = bundle.charms.indexOf('letter-charm') > -1;
    var hasBirthstone = bundle.charms.indexOf('birthstone-charm') > -1;

    var charmSelectorsHtml = '';
    if (hasLetter) {
      var letterOpts = '';
      for (var li = 0; li < LETTERS.length; li++) {
        letterOpts += '<option value="' + LETTERS[li] + '">' + LETTERS[li] + '</option>';
      }
      charmSelectorsHtml +=
        '<div class="ab-v4-config__field">' +
          '<label class="ab-v4-config__label">Initial</label>' +
          '<select class="ab-v4-config__select" id="ab-v4-initial">' + letterOpts + '</select>' +
        '</div>';
    }
    if (hasBirthstone) {
      var bsItems = '';
      for (var bi = 0; bi < BIRTHSTONES.length; bi++) {
        var bs = BIRTHSTONES[bi];
        var border = bs.hex === '#E8E8E8' || bs.hex === '#D4EAEB' || bs.hex === '#7FFFD4' ? '1px solid #ccc' : 'none';
        bsItems +=
          '<div class="ab-v4-bs__item' + (bi === 0 ? ' ab-v4-bs__item--active' : '') + '" data-value="' + bs.stone + '">' +
            '<span class="ab-v4-bs__swatch" style="background:' + bs.hex + ';border:' + border + '"></span>' +
            '<span class="ab-v4-bs__label">' + bs.month + ' — ' + bs.stone + '</span>' +
          '</div>';
      }
      charmSelectorsHtml +=
        '<div class="ab-v4-config__field">' +
          '<label class="ab-v4-config__label">Birthstone</label>' +
          '<div class="ab-v4-bs" id="ab-v4-birthstone">' +
            '<div class="ab-v4-bs__selected" id="ab-v4-bs-toggle">' +
              '<span class="ab-v4-bs__swatch" style="background:' + BIRTHSTONES[0].hex + '"></span>' +
              '<span class="ab-v4-bs__label">' + BIRTHSTONES[0].month + ' — ' + BIRTHSTONES[0].stone + '</span>' +
              '<span class="ab-v4-bs__arrow">&#9662;</span>' +
            '</div>' +
            '<div class="ab-v4-bs__dropdown" id="ab-v4-bs-dropdown">' + bsItems + '</div>' +
          '</div>' +
        '</div>';
    }

    // Build config HTML
    var petFieldsHtml = '';
    if (bundle.hasPetFields) {
      petFieldsHtml =
        '<div class="ab-v4-config__field">' +
          '<label class="ab-v4-config__label">Pet Name <span class="ab-v4-config__hint">(max 8 chars)</span></label>' +
          '<input type="text" class="ab-v4-config__input" id="ab-v4-pet-name" maxlength="8" placeholder="e.g. Bella">' +
        '</div>' +
        '<div class="ab-v4-config__field">' +
          '<label class="ab-v4-config__label">Background</label>' +
          '<div class="ab-v4-config__toggles" data-field="background">' +
            '<button type="button" class="ab-v4-config__toggle-btn ab-v4-config__toggle-btn--active" data-value="Light Gray">Light Gray</button>' +
            '<button type="button" class="ab-v4-config__toggle-btn" data-value="Black">Black</button>' +
          '</div>' +
        '</div>';
    }

    // Create overlay + bottom sheet
    var overlay = createEl('div', { 'class': 'ab-v4-modal' });
    var sheet = createEl('div', { 'class': 'ab-v4-modal__sheet' },
      '<div class="ab-v4-modal__header">' +
        '<div class="ab-v4-modal__handle"></div>' +
        '<button type="button" class="ab-v4-modal__close" aria-label="Close">&times;</button>' +
        '<h3 class="ab-v4-config__title">' + bundle.name + ' Bundle</h3>' +
      '</div>' +
      '<div class="ab-v4-modal__body">' +

        '<div class="ab-v4-config__field">' +
          '<label class="ab-v4-config__label">Base</label>' +
          '<div class="ab-v4-config__toggles ab-v4-config__toggles--base" data-field="base">' +
            '<button type="button" class="ab-v4-config__toggle-btn ab-v4-config__toggle-btn--base ab-v4-config__toggle-btn--active" data-value="0">' +
              '<img class="ab-v4-config__base-img" id="ab-v4-base-img-0" data-silver="https://cdn.shopify.com/s/files/1/0928/6408/files/silver_keeper_1.jpg?v=1777256544" data-gold="https://cdn.shopify.com/s/files/1/0928/6408/files/keeper_bracelet_1.jpg?v=1777256544" src="https://cdn.shopify.com/s/files/1/0928/6408/files/keeper_bracelet_1.jpg?v=1777256544" alt="Keeper Bracelet">' +
              '<span>Keeper Bracelet</span>' +
            '</button>' +
            '<button type="button" class="ab-v4-config__toggle-btn ab-v4-config__toggle-btn--base" data-value="1">' +
              '<img class="ab-v4-config__base-img" id="ab-v4-base-img-1" data-silver="https://cdn.shopify.com/s/files/1/0928/6408/files/paper_clip_2_1.jpg?v=1775238590" data-gold="https://cdn.shopify.com/s/files/1/0928/6408/files/paper_clip_bracelet_2_1.jpg?v=1775239899" src="https://cdn.shopify.com/s/files/1/0928/6408/files/paper_clip_bracelet_2_1.jpg?v=1775239899" alt="Paperclip Bracelet">' +
              '<span>Paperclip Bracelet</span>' +
            '</button>' +
            '<button type="button" class="ab-v4-config__toggle-btn ab-v4-config__toggle-btn--base" data-value="2">' +
              '<img class="ab-v4-config__base-img" id="ab-v4-base-img-2" data-silver="https://cdn.shopify.com/s/files/1/0928/6408/files/delicate_keeper_2_1.jpg?v=1775237951" data-gold="https://cdn.shopify.com/s/files/1/0928/6408/files/delicate_keeper_gold_1.jpg?v=1775239898" src="https://cdn.shopify.com/s/files/1/0928/6408/files/delicate_keeper_gold_1.jpg?v=1775239898" alt="Keeper Necklace">' +
              '<span>Keeper Necklace</span>' +
            '</button>' +
          '</div>' +
        '</div>' +

        '<div class="ab-v4-config__field">' +
          '<label class="ab-v4-config__label">Color <span class="ab-v4-config__hint">(base + charms)</span></label>' +
          '<div class="ab-v4-config__toggles" data-field="color">' +
            '<button type="button" class="ab-v4-config__toggle-btn ab-v4-config__toggle-btn--active" data-value="gold">Gold</button>' +
            '<button type="button" class="ab-v4-config__toggle-btn" data-value="silver">Silver</button>' +
          '</div>' +
        '</div>' +

        charmSelectorsHtml +

        '<div class="ab-v4-config__field">' +
          '<label class="ab-v4-config__label">Upload Your Photo</label>' +
          '<div class="ab-v4-config__upload" id="ab-v4-upload-zone">' +
            '<svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="1.5"><path stroke-linecap="round" stroke-linejoin="round" d="M6.827 6.175A2.31 2.31 0 015.186 7.23c-.38.054-.757.112-1.134.175C2.999 7.58 2.25 8.507 2.25 9.574V18a2.25 2.25 0 002.25 2.25h15A2.25 2.25 0 0021.75 18V9.574c0-1.067-.75-1.994-1.802-2.169a47.865 47.865 0 00-1.134-.175 2.31 2.31 0 01-1.64-1.055l-.822-1.316a2.192 2.192 0 00-1.736-1.039 48.774 48.774 0 00-5.232 0 2.192 2.192 0 00-1.736 1.039l-.821 1.316z"/><path stroke-linecap="round" stroke-linejoin="round" d="M16.5 12.75a4.5 4.5 0 11-9 0 4.5 4.5 0 019 0z"/></svg>' +
            '<span>Tap to upload photo</span>' +
            '<input type="file" id="ab-v4-photo-input" accept="image/*" style="display:none">' +
          '</div>' +
        '</div>' +

        petFieldsHtml +

      '</div>' +
      '<div class="ab-v4-modal__footer">' +
        '<button type="button" class="ab-v4-config__atc" id="ab-v4-atc-btn" disabled>Upload a photo to continue</button>' +
      '</div>'
    );

    overlay.appendChild(sheet);
    document.body.appendChild(overlay);
    document.body.classList.add('ab-v4-modal-open');
    document.body.style.overflow = 'hidden';

    // Trigger open animation on next frame
    requestAnimationFrame(function () {
      overlay.classList.add('ab-v4-modal--open');
      sheet.classList.add('ab-v4-modal__sheet--open');
    });

    // --- Price updater ---
    var atcBtn = sheet.querySelector('#ab-v4-atc-btn');

    function getModalPriceText() {
      return formatMoney(getBundlePrice(bundle, productMap, configState.color, configState.baseIndex));
    }

    function getModalPriceHtml() {
      return formatMoney(getBundlePrice(bundle, productMap, configState.color, configState.baseIndex));
    }

    function updateModalPrice() {
      var priceHtml = getModalPriceHtml();
      if (configState.photoUrl) {
        atcBtn.innerHTML = 'Add Bundle to Cart &mdash; ' + priceHtml;
      } else {
        atcBtn.innerHTML = 'Upload a photo to continue &mdash; ' + priceHtml;
      }
    }
    updateModalPrice();

    // --- Wire up event listeners ---

    // Close on overlay click or X button
    overlay.addEventListener('click', function (e) {
      if (e.target === overlay) closeModal();
    });
    sheet.querySelector('.ab-v4-modal__close').addEventListener('click', closeModal);

    // Toggle buttons
    var toggleGroups = sheet.querySelectorAll('.ab-v4-config__toggles');
    for (var g = 0; g < toggleGroups.length; g++) {
      (function (group) {
        var btns = group.querySelectorAll('.ab-v4-config__toggle-btn');
        for (var b = 0; b < btns.length; b++) {
          btns[b].addEventListener('click', function (e) {
            var clicked = e.target.closest('.ab-v4-config__toggle-btn');
            if (!clicked) return;
            for (var x = 0; x < btns.length; x++) {
              btns[x].classList.remove('ab-v4-config__toggle-btn--active');
            }
            clicked.classList.add('ab-v4-config__toggle-btn--active');

            var field = group.getAttribute('data-field');
            var val = clicked.getAttribute('data-value');
            if (field === 'base') configState.baseIndex = parseInt(val, 10);
            if (field === 'color') {
              configState.color = val;
              var baseImgs = sheet.querySelectorAll('.ab-v4-config__base-img');
              for (var bi = 0; bi < baseImgs.length; bi++) {
                var swap = baseImgs[bi].getAttribute('data-' + val);
                if (swap) baseImgs[bi].src = swap;
              }
            }
            if (field === 'background') configState.petBackground = val;
            if (field === 'base' || field === 'color') updateModalPrice();
          });
        }
      })(toggleGroups[g]);
    }

    // Initial dropdown
    var initialSelect = sheet.querySelector('#ab-v4-initial');
    if (initialSelect) {
      initialSelect.addEventListener('change', function (e) {
        configState.initial = e.target.value;
      });
    }

    // Birthstone custom dropdown
    var bsToggle = sheet.querySelector('#ab-v4-bs-toggle');
    var bsDropdown = sheet.querySelector('#ab-v4-bs-dropdown');
    if (bsToggle && bsDropdown) {
      bsToggle.addEventListener('click', function () {
        bsDropdown.classList.toggle('ab-v4-bs__dropdown--open');
      });
      var bsItems = bsDropdown.querySelectorAll('.ab-v4-bs__item');
      for (var bsi = 0; bsi < bsItems.length; bsi++) {
        bsItems[bsi].addEventListener('click', function () {
          var val = this.getAttribute('data-value');
          configState.birthstone = val;
          // Update active state
          for (var x = 0; x < bsItems.length; x++) {
            bsItems[x].classList.remove('ab-v4-bs__item--active');
          }
          this.classList.add('ab-v4-bs__item--active');
          // Update the toggle display
          var swatch = this.querySelector('.ab-v4-bs__swatch');
          var label = this.querySelector('.ab-v4-bs__label');
          bsToggle.querySelector('.ab-v4-bs__swatch').style.background = swatch.style.background;
          bsToggle.querySelector('.ab-v4-bs__swatch').style.border = swatch.style.border;
          bsToggle.querySelector('.ab-v4-bs__label').textContent = label.textContent;
          bsDropdown.classList.remove('ab-v4-bs__dropdown--open');
        });
      }
      // Close dropdown on outside click
      document.addEventListener('click', function (e) {
        if (!e.target.closest('#ab-v4-birthstone')) {
          bsDropdown.classList.remove('ab-v4-bs__dropdown--open');
        }
      });
    }

    // ATC validation — checks photo + pet name (if pet bundle)
    var uploadZone = sheet.querySelector('#ab-v4-upload-zone');
    var photoInput = sheet.querySelector('#ab-v4-photo-input');
    var modalBody = sheet.querySelector('.ab-v4-modal__body');

    function updateAtcState() {
      var ready = !!configState.photoUrl;
      if (bundle.hasPetFields && !configState.petName.trim()) {
        ready = false;
      }
      atcBtn.disabled = !ready;
      var priceHtml = getModalPriceHtml();
      if (ready) {
        atcBtn.innerHTML = 'Add Bundle to Cart &mdash; ' + priceHtml;
      } else if (configState.photoUrl && bundle.hasPetFields && !configState.petName.trim()) {
        atcBtn.innerHTML = 'Enter pet name to continue &mdash; ' + priceHtml;
      } else {
        atcBtn.innerHTML = 'Upload a photo to continue &mdash; ' + priceHtml;
      }
    }

    // Pet name input
    var petNameInput = sheet.querySelector('#ab-v4-pet-name');
    if (petNameInput) {
      petNameInput.addEventListener('input', function (e) {
        configState.petName = e.target.value.substring(0, 8);
        updateAtcState();
      });
    }

    // Photo upload
    uploadZone.addEventListener('click', function () {
      photoInput.click();
    });

    function onUploadDone() {
      updateAtcState();
      setTimeout(function () {
        var petNameField = sheet.querySelector('#ab-v4-pet-name');
        var scrollTarget = petNameField || uploadZone;
        if (scrollTarget) {
          scrollTarget.scrollIntoView({ behavior: 'smooth', block: 'center' });
        }
      }, 300);
    }

    photoInput.addEventListener('change', function (e) {
      var file = e.target.files && e.target.files[0];
      if (!file) return;
      if (bundle.circleRender === 'CIRCLE' && typeof pintura !== 'undefined') {
        openPinturaCircleCrop(file, uploadZone, atcBtn, onUploadDone);
      } else {
        resizeAndUpload(file, uploadZone, atcBtn, onUploadDone);
      }
    });

    // Add to cart button
    atcBtn.addEventListener('click', function () {
      if (!configState.photoUrl) return;
      if (bundle.hasPetFields && !configState.petName.trim()) return;
      atcBtn.disabled = true;
      atcBtn.textContent = 'Adding to cart...';
      addBundleToCart(configState, productMap, function (success) {
        if (success) {
          closeModal();
          // Open cart drawer
          if (typeof jQuery !== 'undefined') {
            jQuery(document.body).trigger('added.ajaxProduct');
          }
        } else {
          atcBtn.disabled = false;
          atcBtn.textContent = 'Error \u2014 try again';
          setTimeout(function () {
            atcBtn.innerHTML = 'Add Bundle to Cart &mdash; ' + getModalPriceHtml();
          }, 2000);
        }
      });
    });
  }

  /* ========================================================================
     Pintura circle crop — for CIRCLE render bundles (Faith, Mothers)
     ======================================================================== */
  function openPinturaCircleCrop(file, uploadZone, atcBtn, onUploadDone) {
    console.log('[AB V3 Pintura] Starting circle crop, file:', file.name, file.type, file.size);
    // Read file as data URL first, then open editor
    var reader = new FileReader();
    reader.onerror = function () {
      console.error('[AB V3 Pintura] FileReader error:', reader.error);
    };
    reader.onload = function (readerEvent) {
      var dataUrl = readerEvent.target.result;
      console.log('[AB V3 Pintura] FileReader done, dataUrl length:', dataUrl.length, 'prefix:', dataUrl.substring(0, 50));
      showPinturaModal(dataUrl, uploadZone, atcBtn, onUploadDone);
    };
    reader.readAsDataURL(file);
  }

  function showPinturaModal(dataUrl, uploadZone, atcBtn, onUploadDone) {
    console.log('[AB V3 Pintura] showPinturaModal called');
    console.log('[AB V3 Pintura] pintura available:', typeof pintura, 'appendDefaultEditor:', typeof pintura.appendDefaultEditor, 'createDefaultImageReader:', typeof pintura.createDefaultImageReader);
    // Overlay behind the modal
    var overlay = document.createElement('div');
    overlay.style.cssText = 'position:fixed;top:0;left:0;width:100%;height:100%;z-index:10001;background:rgba(0,0,0,0.6);display:flex;align-items:center;justify-content:center;';

    // Modal box
    var modal = document.createElement('div');
    modal.style.cssText = 'width:90%;max-width:500px;height:80vh;max-height:600px;background:#fff;border-radius:12px;overflow:hidden;box-shadow:0 20px 60px rgba(0,0,0,0.4);display:flex;flex-direction:column;position:relative;';

    // X close button
    var closeBtn = document.createElement('button');
    closeBtn.innerHTML = '&times;';
    closeBtn.style.cssText = 'position:absolute;top:8px;right:8px;z-index:10;width:32px;height:32px;border:none;background:rgba(0,0,0,0.5);color:#fff;font-size:20px;line-height:1;border-radius:50%;cursor:pointer;display:flex;align-items:center;justify-content:center;';
    modal.appendChild(closeBtn);

    var editorContainer = document.createElement('div');
    editorContainer.id = 'ab-v4-pintura-modal';
    editorContainer.style.cssText = 'flex:1;min-height:0;';
    modal.appendChild(editorContainer);

    // Upload button at the bottom
    var uploadBtn = document.createElement('button');
    uploadBtn.textContent = 'Upload Photo';
    uploadBtn.style.cssText = 'width:100%;padding:14px;border:none;background:#000;color:#fff;font-family:Futura,"Futura Medium",sans-serif;font-size:14px;font-weight:600;letter-spacing:0.08em;text-transform:uppercase;cursor:pointer;';
    modal.appendChild(uploadBtn);

    overlay.appendChild(modal);
    document.body.appendChild(overlay);

    // Hide Pintura's built-in export button, show nav tools
    var styleOverride = document.createElement('style');
    styleOverride.textContent =
      '#ab-v4-pintura-modal .PinturaButtonExport { display: none !important; }' +
      '#ab-v4-pintura-modal .PinturaNavMain { display: flex !important; }' +
      '#ab-v4-pintura-modal .PinturaNavTools { display: flex !important; }';
    document.head.appendChild(styleOverride);

    function cleanup() {
      styleOverride.remove();
      overlay.remove();
    }

    // Close on overlay click, X button
    overlay.addEventListener('click', function (e) {
      if (e.target === overlay) { pinturaEditor.destroy(); cleanup(); }
    });
    closeBtn.addEventListener('click', function () {
      pinturaEditor.destroy(); cleanup();
    });

    var pinturaEditor = pintura.appendDefaultEditor(editorContainer, {
      src: dataUrl,
      utils: ['crop'],
      enableButtonExport: false,
      imageCropAspectRatio: 1,
      cropEnableButtonFlipHorizontal: false,
      cropEnableButtonFlipVertical: false,
      imageCropLimitToImage: true,
      imageReader: pintura.createDefaultImageReader(),
      willRenderCanvas: function (shapes, state) {
        if (state.utilVisibility.crop <= 0) return shapes;
        var sel = state.selectionRect;
        return Object.assign({}, shapes, {
          interfaceShapes: [{
            x: sel.x + sel.width * 0.5,
            y: sel.y + sel.height * 0.5,
            rx: sel.width * 0.5,
            ry: sel.height * 0.5,
            opacity: state.utilVisibility.crop,
            inverted: true,
            backgroundColor: [].concat(state.backgroundColor, [0.5]),
            strokeWidth: 1,
            strokeColor: state.lineColor
          }].concat(shapes.interfaceShapes)
        });
      },
      imageWriter: pintura.createDefaultImageWriter({
        mimeType: 'image/jpeg',
        quality: 0.5,
        targetSize: { width: 1000, height: 1000, fit: 'contain', upscale: false },
        postprocessImageData: function (imageData) {
          return new Promise(function (resolve) {
            var canvas = document.createElement('canvas');
            canvas.width = imageData.width;
            canvas.height = imageData.height;
            var ctx = canvas.getContext('2d');
            ctx.putImageData(imageData, 0, 0);
            ctx.globalCompositeOperation = 'destination-in';
            ctx.fillStyle = 'black';
            ctx.beginPath();
            ctx.arc(imageData.width * 0.5, imageData.height * 0.5, imageData.width * 0.5, 0, 2 * Math.PI);
            ctx.fill();
            resolve(ctx.getImageData(0, 0, canvas.width, canvas.height));
          });
        }
      })
    });

    pinturaEditor.on('load', function () {
      console.log('[AB V3 Pintura] Image loaded successfully');
      // Debug: inspect Pintura DOM
      var root = editorContainer.querySelector('.PinturaRoot');
      console.log('[AB V3 Pintura] PinturaRoot:', root, 'size:', root && root.offsetWidth, 'x', root && root.offsetHeight);
      var canvases = editorContainer.querySelectorAll('canvas');
      console.log('[AB V3 Pintura] Canvas count:', canvases.length);
      for (var ci = 0; ci < canvases.length; ci++) {
        var c = canvases[ci];
        console.log('[AB V3 Pintura] Canvas', ci, ':', c.width, 'x', c.height, 'offset:', c.offsetWidth, 'x', c.offsetHeight, 'display:', getComputedStyle(c).display, 'visibility:', getComputedStyle(c).visibility, 'opacity:', getComputedStyle(c).opacity);
      }
      // Check container chain heights
      var el = editorContainer;
      while (el && el !== document.body) {
        console.log('[AB V3 Pintura] Parent:', el.tagName + (el.className ? '.' + el.className.split(' ')[0] : ''), 'size:', el.offsetWidth, 'x', el.offsetHeight, 'overflow:', getComputedStyle(el).overflow);
        el = el.parentElement;
      }
    });

    pinturaEditor.on('loaderror', function (err) {
      console.error('[AB V3 Pintura] Image load error:', err);
    });

    // Upload button triggers Pintura processing then Cloudinary upload
    uploadBtn.addEventListener('click', function () {
      uploadBtn.disabled = true;
      uploadBtn.textContent = 'Processing...';
      pinturaEditor.processImage().then(function (result) {
        console.log('[AB V3 Pintura] Process complete, dest:', result.dest);
        cleanup();
        uploadToCloudinary(result.dest, uploadZone, atcBtn, onUploadDone);
      }).catch(function (err) {
        console.error('[AB V3 Pintura] Process error:', err);
        uploadBtn.disabled = false;
        uploadBtn.textContent = 'Upload Photo';
      });
    });

    pinturaEditor.on('close', function () {
      console.log('[AB V3 Pintura] Editor closed');
      cleanup();
    });
  }

  /* ========================================================================
     Photo upload — client-side resize + Cloudinary XHR
     ======================================================================== */
  function resizeAndUpload(file, uploadZone, atcBtn, onUploadDone) {
    uploadZone.innerHTML =
      '<div class="ab-v4-config__upload-progress">' +
        '<div class="ab-v4-config__upload-progress-bar" id="ab-v4-progress-bar"></div>' +
      '</div>' +
      '<span>Preparing image...</span>';

    var reader = new FileReader();
    reader.onload = function (e) {
      var img = new Image();
      img.onload = function () {
        // Resize to MAX_IMAGE_SIZE x MAX_IMAGE_SIZE
        var canvas = document.createElement('canvas');
        var w = img.width;
        var h = img.height;
        var scale = Math.min(MAX_IMAGE_SIZE / w, MAX_IMAGE_SIZE / h, 1);
        canvas.width = Math.round(w * scale);
        canvas.height = Math.round(h * scale);
        var ctx = canvas.getContext('2d');
        ctx.drawImage(img, 0, 0, canvas.width, canvas.height);

        canvas.toBlob(function (blob) {
          if (!blob) {
            uploadZone.innerHTML = '<span>Resize failed. Tap to retry.</span>';
            return;
          }
          uploadToCloudinary(blob, uploadZone, atcBtn, onUploadDone);
        }, 'image/jpeg', 0.85);
      };
      img.onerror = function () {
        uploadZone.innerHTML = '<span>Could not read image. Tap to retry.</span>';
      };
      img.src = e.target.result;
    };
    reader.readAsDataURL(file);
  }

  function uploadToCloudinary(blob, uploadZone, atcBtn, onUploadDone) {
    uploadZone.querySelector('span').textContent = 'Uploading...';

    var formData = new FormData();
    formData.append('file', blob, 'photo.jpg');
    formData.append('upload_preset', CLOUDINARY_PRESET);

    var xhr = new XMLHttpRequest();
    xhr.open('POST', CLOUDINARY_URL);

    xhr.upload.onprogress = function (e) {
      if (e.lengthComputable) {
        var pct = Math.round((e.loaded / e.total) * 100);
        var bar = document.getElementById('ab-v4-progress-bar');
        if (bar) bar.style.width = pct + '%';
      }
    };

    xhr.onload = function () {
      if (xhr.status >= 200 && xhr.status < 300) {
        try {
          var data = JSON.parse(xhr.responseText);
          configState.photoUrl = data.secure_url || data.url || '';

          // Show preview
          var previewSrc = configState.photoUrl;
          var split = previewSrc.split('/upload/');
          if (split.length === 2) {
            previewSrc = split[0] + '/upload/c_limit,h_250/' + split[1];
          }

          var circleClass = configState.bundle && configState.bundle.circleRender === 'CIRCLE' ? ' ab-v4-config__upload-preview--circle' : '';
          uploadZone.innerHTML =
            '<img class="ab-v4-config__upload-preview' + circleClass + '" src="' + previewSrc + '" alt="Photo preview">' +
            '<span class="ab-v4-config__upload-change">Tap to change</span>' +
            '<input type="file" id="ab-v4-photo-input" accept="image/*" style="display:none">';

          // Re-attach file input listener
          var newInput = uploadZone.querySelector('#ab-v4-photo-input');
          newInput.addEventListener('change', function (ev) {
            var f = ev.target.files && ev.target.files[0];
            if (f) resizeAndUpload(f, uploadZone, atcBtn, onUploadDone);
          });

          // Notify caller of successful upload
          if (typeof onUploadDone === 'function') onUploadDone();
        } catch (e) {
          uploadZone.innerHTML = '<span>Upload error. Tap to retry.</span>';
        }
      } else {
        uploadZone.innerHTML = '<span>Upload failed. Tap to retry.</span>';
      }
    };

    xhr.onerror = function () {
      uploadZone.innerHTML = '<span>Upload failed. Tap to retry.</span>';
    };

    xhr.send(formData);
  }

  /* ========================================================================
     Add to cart — builds multi-item /cart/add.js request
     ======================================================================== */
  function addBundleToCart(state, productMap, callback) {
    var bundle = state.bundle;
    var color = state.color;
    var items = [];
    var bundleId = 'charm_bundle_' + Date.now() + '_' + Math.random().toString(36).substr(2, 6);

    console.log('[AB V4] addBundleToCart state:', { color: state.color, initial: state.initial, birthstone: state.birthstone, baseIndex: state.baseIndex });

    // 1. Base variant
    var base = BASES[state.baseIndex];
    var baseProduct = productMap[base.handle];
    var baseVariant = getBaseVariant(base, productMap, color);
    if (!baseVariant) { callback(false); return; }

    console.log('[AB V4] Base variant:', baseVariant.title, 'id:', baseVariant.id, 'color:', color);

    // Build parent properties with visible charm titles
    // Use _charm_bundle_* (not _slider_bundle_*) so the Cart Transform doesn't
    // merge and strip properties — ajax-cart.js handles visual combining instead
    var baseProperties = {
      _charm_bundle_id: bundleId,
      _charm_bundle_parent: 'true',
      _charm_bundle_charm_count: String(bundle.charms.length)
    };
    // Charm N titles are set below in the charm loop (after variant selection)
    // so we can include variant-specific details like initial/birthstone

    // Copy photo + render shape to parent so cart drawer shows the preview
    if (state.photoUrl) {
      baseProperties.photo = state.photoUrl;
      baseProperties._circlerender = bundle.circleRender;
    }

    items.push({
      id: baseVariant.id,
      quantity: 1,
      properties: baseProperties
    });

    // 2. Charms
    for (var i = 0; i < bundle.charms.length; i++) {
      var charmHandle = bundle.charms[i];
      var charmProduct = productMap[charmHandle];
      var charmVariant;

      // Use specific variant for letter and birthstone charms
      if (charmHandle === 'letter-charm') {
        charmVariant = getVariantByColorAndOption(charmProduct, color, state.initial);
      } else if (charmHandle === 'birthstone-charm') {
        charmVariant = getVariantByColorAndOption(charmProduct, color, state.birthstone);
      } else {
        charmVariant = getVariantByColor(charmProduct, color);
      }
      if (!charmVariant) { callback(false); return; }

      console.log('[AB V4] Charm', charmHandle, '→', charmVariant.title, 'id:', charmVariant.id);

      // Set variant-specific charm title on the parent base item
      var charmDisplayTitle = charmProduct.title;
      if (charmHandle === 'letter-charm') {
        charmDisplayTitle += ' - ' + state.initial;
      } else if (charmHandle === 'birthstone-charm') {
        charmDisplayTitle += ' - ' + state.birthstone;
      }
      baseProperties['Charm ' + (i + 1)] = charmDisplayTitle;

      var item = {
        id: charmVariant.id,
        quantity: 1,
        properties: {
          _charm_bundle_id: bundleId,
          _charm_bundle_child: 'true',
          _slot_position: String(i + 1),
          _charm_title: charmProduct.title
        }
      };

      // Add properties to the custom charm
      if (charmHandle === bundle.customCharm) {
        item.properties.photo = state.photoUrl;
        item.properties._circlerender = bundle.circleRender;
        if (bundle.hasPetFields) {
          if (state.petName) {
            item.properties.Name = state.petName;
          }
          item.properties.Background = state.petBackground;
        }
      }

      items.push(item);
    }

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: items })
    })
      .then(function (res) {
        if (!res.ok) throw new Error('Cart add failed: ' + res.status);
        return res.json();
      })
      .then(function () {
        // Trigger cart stamp and cart drawer
        if (typeof jQuery !== 'undefined') {
          jQuery(document.body).trigger('afterAddItem.ajaxCart');
        }

        // Track bundle selection
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
          event: 'ab_test_bundle_selected',
          ab_test_name: 'charm_quickstart_bundles_v4',
          bundle_id: bundle.id,
          bundle_base: BASES[state.baseIndex].label,
          bundle_color: color
        });

        callback(true);
      })
      .catch(function (err) {
        console.error('[AB V4] Cart add error:', err);
        callback(false);
      });
  }

  /* ========================================================================
     Main — bundle cards (V4-B winner) ship to 100% of users.
     Basics sell at the $8 catalog price (V6 winner, repriced 2026-06); the
     photo family sells at the V7-C ladder prices (V7 winner, repriced
     2026-08). All prices come straight from the catalog via /products/*.json
     — no test-era fetch patching remains. No per-builder bump needed.
     ======================================================================== */
  loadCSS();

  function applyBundles() {
    fetchAllProductData(function (productMap) {
      renderBundleCards(productMap);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', applyBundles);
  } else {
    applyBundles();
  }
})();
